export const environment = {
  production: false,

  // API key for google maps
  GOOGLE_MAPS_API_KEY: "AIzaSyDTAnbYHkvbKFbYmWr10P918lcgqpwpDtk",

  DOMAIN: `https://apis.onstak.ai/services/va-platform`,
  IDENTITY: `https://apis.onstak.ai/services/identity`,
  CORE: `https://apis.onstak.ai/services/iot-platform`,
  MERAKI: `https://api.meraki.com`,
  mode: "local",
  ProjectName: "va",
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
